module.exports = __webpack_public_path__ + "static/media/yuandanCore2.50ca88a3.png";